import { API } from '../Api';

/**
 * eKYC tự động (REQ Phase 2 — mục II): OCR CCCD + liveness khuôn mặt qua VNPT IDG.
 * Gọi cab-user-service qua gateway /v1/user-service/Ekyc/... (gateway tự inject auid).
 * BE trả dạng { statusCode, message, data } → các hàm dưới trả thẳng `data`.
 */

const BASE = '/v1/user-service/Ekyc';

export interface EkycOcrResult {
  name: string;
  idNumber: string;
  dob?: string;
  address?: string;
}

export interface EkycLivenessResult {
  livenessPassed: boolean;
  faceMatchScore?: number;
  isVerified: boolean;
  message?: string;
}

export interface EkycStatus {
  isVerified: boolean;
  verifiedName?: string;
  /** Số căn cước đã che, chỉ còn 4 số cuối. */
  idNumber?: string | null;
  verifiedAt?: string | null;
  /** Số lần hỏng kể từ lần admin mở lại gần nhất. */
  failedAttempts?: number;
  /** Số lần hỏng tối đa; 0 là không giới hạn. */
  maxFailedAttempts?: number;
  /** Số lượt còn lại; null khi không giới hạn. */
  attemptsLeft?: number | null;
  /** Đã hết lượt, phải nhắn hỗ trợ để được mở lại. */
  locked?: boolean;
}

/** OCR mặt trước (+ sau nếu có). frontImage/backImage là Blob/File chụp từ camera. */
export const verifyEkycDocument = async (
  frontImage: Blob,
  backImage?: Blob | null
): Promise<EkycOcrResult> => {
  const fd = new FormData();
  fd.append('frontImage', frontImage, 'cccd-front.jpg');
  if (backImage) fd.append('backImage', backImage, 'cccd-back.jpg');
  const res = await API.post(`${BASE}/verify-document`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.data ?? res.data;
};

/** Liveness khuôn mặt; gửi kèm ảnh CCCD để VNPT so khớp chân dung. */
export const checkEkycLiveness = async (
  faceImage: Blob,
  idCardImage?: Blob | null
): Promise<EkycLivenessResult> => {
  const fd = new FormData();
  fd.append('faceVideoOrImage', faceImage, 'face.jpg');
  if (idCardImage) fd.append('idCardImage', idCardImage, 'cccd-front.jpg');
  const res = await API.post(`${BASE}/liveness-check`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.data ?? res.data;
};

export const getEkycStatus = async (): Promise<EkycStatus> => {
  const res = await API.get(`${BASE}/status`);
  return res.data?.data ?? res.data;
};
